import React from 'react'
import { component_tool } from '@/tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
          title: '路径名称',
          name: 'name',
          dataIndex: 'name',
          searchItem: {},
          tableItem: {}
      },
      {
          title: '阶段数量',
          name: 'validStageCount',
          dataIndex: 'validStageCount',
          searchItem: {},
          tableItem: {
              width: 300
          }
      }

    ]
}
